import dayjs from 'dayjs'
// eslint-disable-next-line import/no-extraneous-dependencies
import moment, { Moment } from 'moment'

const TIMEZONE_TO_REGION = {
  'America/Sao_Paulo': 'br',
  'America/Manaus': 'br',
  'America/Campo_Grande': 'br',
  'America/Rio_Branco': 'br',
  'America/Belem': 'br',
  'America/Fortaleza': 'br',
  'America/Recife': 'br',
  'America/Bahia': 'br',

  'Asia/Jakarta': 'id',
  'Asia/Makassar': 'id',
  'Asia/Jayapura': 'id',

  'Asia/Shanghai': 'cn',
  'Asia/Kuala_Lumpur': 'my',
  'Asia/Manila': 'ph',
  'Asia/Singapore': 'sg',
  'Asia/Bangkok': 'th',
  'Asia/Taipei': 'tw',
  'Asia/Ho_Chi_Minh': 'vn'
}

// 将传入的数字转换成另外一个毫秒数，主要用于给后台传递时间这里表示的含义是 比如北京时间 2022-08-21 00:00:00在印尼地区2022-08-21 00:00:00的时间戳
export default function timeZoneValueOf(d: number | Date | dayjs.Dayjs | Moment) {
  let time
  // 拿到当前浏览器时间的毫秒数
  if (d instanceof moment) {
    time = d.valueOf()
  } else {
    time = dayjs(d as any).valueOf()
  }
  const dd = new Date(time)
  // 转换成秒
  const offset = dd.getTimezoneOffset() * -1
  const timezoneOffset = dayjs.tz(time).utcOffset()
  return time + (offset - timezoneOffset) * 60 * 1000
}

export function guessRegionByTimeZone() {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return TIMEZONE_TO_REGION[timeZone] || 'unknown'
}
